import { useEffect } from "react";
import { SEO } from "@components";
import { getBasicQueryVars, getPageTitle } from "@/core/utils";
import { FaustTemplate, useFaustQuery } from "@faustwp/core";
import { GetFrontPageDataQuery } from "@graphqlTypes";
import { FlexibleContentMap } from "@/components/ComponentMaps";
import { usePageHighlight } from "@/providers/PageHighlightContext";
import { HIGHLIGHT_COLOR_BY_TYPE, HIGHLIGHT_COLORS } from "@/core/constants";
import { usePageLoading } from "@/providers/LoadingContext";
import { useTrackRouteChange } from "@/providers/TrackingContext";
import { FrontPageQuery } from "@/queries/FrontPage";

const HomePage: FaustTemplate<any> = ({ loading, pageWrapperData }: FaustPageProps<any>) => {
  const { setHighlightColor } = usePageHighlight();
  const data = useFaustQuery<GetFrontPageDataQuery>(FrontPageQuery);
  const { listInductees, flexiblePageContent, pageData: { ogDescription, featuredImage, pageCategory } = {} } = data?.rhPage || {};
  const { siteSettings: { customSettings } = {}, recentStories } = pageWrapperData;
  const { siteTitle } = customSettings;
  const { previewLoading, setPreviewLoading } = usePageLoading();
  const pageTitle = getPageTitle(siteTitle);
  const [category] = pageCategory || [];

  useEffect(() => {
    setHighlightColor(HIGHLIGHT_COLOR_BY_TYPE[category?.slug] || HIGHLIGHT_COLORS.GREEN);
  }, [category]);

  useTrackRouteChange(category?.slug);

  useEffect(() => {
    if (!loading && previewLoading) setPreviewLoading(false);
  }, [loading, previewLoading]);
  
  if (!data || loading) return;
  return (
    <>
      <SEO title={pageTitle} description={ogDescription} image={featuredImage} />
      <FlexibleContentMap
        content={flexiblePageContent?.content}
        listInductees={listInductees?.nodes}
        recentStories={recentStories}
      />
    </>
  );
};

HomePage.queries = [
  {
    query: FrontPageQuery,
    variables: getBasicQueryVars,
  },
]

export default HomePage;
